<template>
    <v-layout class="layout-has_background" column align-center justify-space-between>
        <img src="/static/img/logo.png" class="login-img" alt="" height="150"/>
        <v-form @submit="auth" v-model="hasErrors" class="login-form">
            <v-flex xs12 sm12>
                <v-text-field
                    ref="email"
                    v-model="form.email"
                    label="Логин"
                    single-line
                    solo
                    text
                    required
                    :rules="[rules.required]"/>
            </v-flex>

            <v-flex xs12 sm12>
                <v-text-field
                    ref="password"
                    v-model="form.password"
                    label="Пароль"
                    type="password"
                    single-line
                    solo
                    text
                    required
                    :rules="[rules.required]"/>
            </v-flex>

            <v-flex xs12 sm12>
                <v-btn text @click="auth" class="login-submit ma-0">Войти</v-btn>
            </v-flex>

            <v-dialog v-model="loading" width="300">
                <v-card color="secondary" dark>
                    <v-card-text>
                        Пожалуйста подождите
                        <v-progress-linear indeterminate color="primary" class="mb-0"/>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-form>
        <Footer/>
    </v-layout>
</template>

<script>
    import axios from 'axios'
    import auth from '../../api/auth'
    import Footer from '../../components/Footer/Layout'

    export default {
        name: 'Login',
        components: { Footer },
        data: () => ({
            hasErrors: false,
            form: {
                email: '',
                password: ''
            },
            rules: {
                required: value => !!value || 'Поле не может быть пустым.'
            },
            loading: false
        }),

        created () {
            this.setHeaderTitle('Авторизация')
        },

        mounted () {
            this.form.email = process.env.NODE_ENV === 'development' ? 'admin@madmurlocksquad.uz' : ''
            this.form.password = process.env.NODE_ENV === 'development' ? 'adm1n' : ''
        },

        methods: {
            auth () {
                this.loading = true
                this.hasErrors = false

                Object.keys(this.form).forEach(f => {
                    if (!this.form[f]) {
                        this.hasErrors = true
                    }

                    this.$refs[f].validate(true)
                })

                if (this.hasErrors) {
                    this.loading = false
                    return
                }

                auth
                    .login(this.form)
                    .then(response => {
                        let projectKey = response.data.data.project.projectKey
                        axios.defaults.headers.common['api-token'] = response.data.data.api_token
                        axios.defaults.headers.common['project-key'] = projectKey

                        const token = {
                            body: response.data.data.api_token,
                            expired_at: new Date(response.data.data.api_token_expiration).getTime()
                        }

                        sessionStorage.setItem('user', JSON.stringify(response.data))
                        sessionStorage.setItem('token', JSON.stringify(token))
                        sessionStorage.setItem('projectKey', projectKey)

                        this.$store.commit('loginUser', response.data)


                        // this.$cookie.set("projectKey", response.data.data.projectKey)
                        this.$router.push({ name: 'home' })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                    .finally(() => this.loading = false)
            }
        },
        watch: {
            name () {
                this.errors = ''
            }
        }
    }
</script>

<style lang="scss">
    @import "../../assets/styles/colors";

    .login {
        &-form {
            width: 300px;
            padding: 24px 0;
        }

        &-submit {
            width: 100%;
            height: 48px;
            background-color: $color1 !important;

            .v-btn__content {
                color: $white;
            }
        }

        &-img {
            opacity: 0;
            visibility: hidden;
        }
    }
</style>
